import { UserSettings } from '@screens';

export const UserSettingsScreen = () => {
    return <UserSettings />;
};
